import { render, staticRenderFns } from "./layout-text-cl.vue?vue&type=template&id=956dc5f8"
import script from "./layout-text-cl.vue?vue&type=script&lang=js"
export * from "./layout-text-cl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('956dc5f8')) {
      api.createRecord('956dc5f8', component.options)
    } else {
      api.reload('956dc5f8', component.options)
    }
    module.hot.accept("./layout-text-cl.vue?vue&type=template&id=956dc5f8", function () {
      api.rerender('956dc5f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/layout/text/layout-text-cl.vue"
export default component.exports